import React, { useState, useCallback } from "react";
import { useMountedState } from "react-use";
import { Button, Flex, Modal, toast } from "@jsq/ds/core";

export type DeletePaymentPrefModalProps = {
  show: boolean;
  onClose: () => void;
  deleteCallback: () => Promise<void>;
};

export const DeletePaymentPrefModal: React.FC<DeletePaymentPrefModalProps> = (props) => {
  const { show, onClose, deleteCallback } = props;
  const [isLoading, setIsLoading] = useState(false);
  const isMounted = useMountedState();

  const onDeleteButtonClick = useCallback(async () => {
    setIsLoading(true);
    try {
      await deleteCallback();
    } catch (e) {
      toast.error("Something went wrong. Please try again.");
      setIsLoading(false);
      return;
    }
    if (isMounted()) {
      setIsLoading(false);
    }
    toast.success("Payment instruction deleted.");
    onClose();
  }, [deleteCallback, onClose, isMounted]);

  return (
    <Modal data-testid="delete-payment-pref-modal" onHide={onClose} show={show} size="small">
      <Modal.Header closeButton>
        <Modal.Title>Delete payment instructions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Flex flexDirection="column">
          <p>
            Are you sure you want to delete these payment instructions? Deleted payment
            instructions will remain linked to historical payment records but will not be used
            when creating new payments.
          </p>
        </Flex>
      </Modal.Body>
      <Modal.Footer>
        <Flex flexDirection="row" justifyContent="flex-end" gap={10}>
          <Button variant="neutral" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="danger"
            isLoading={isLoading}
            onClick={() => void onDeleteButtonClick()}
          >
            Delete
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
};

export default DeletePaymentPrefModal;
